




























import { DraftCompanyParams } from '@/store/interfaces/drafts';
import drafts from '@/store/types/drafts';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import InboundCard from './inboundCard.vue';
import DescriptionValue from '@/components/Reusable/descriptionValue.vue';
import ContactForm from './forms/contacts.vue';

@Component({ components: { InboundCard, DescriptionValue, ContactForm, }, })
export default class Contacts extends Vue {
  edit = false;
  editThrows(value: boolean): void {
    this.edit = value;
  }

  @Getter(`drafts/${drafts.getters.GET_DRAFT_COMPANY}`)
  draftCompany!: DraftCompanyParams;
}
